import { FixaListViewItem } from "@coworker/apprestructured/src/shared/wrappers/FixaListView/FixaListViewItem";

type MenuSheetItemProps = {
  title: string;
  onClick: () => void;
  disabled?: boolean | undefined;
  testId?: string;
};

function MenuSheetItem({
  title,
  onClick,
  disabled = false,
  testId = "",
}: MenuSheetItemProps) {
  return (
    <FixaListViewItem
      data-testid={testId}
      type="button"
      title={title}
      onClick={onClick}
      control="navigational"
      controlIcon={null}
      disabled={disabled}
    />
  );
}

export default MenuSheetItem;
